import React, { useEffect } from 'react';

const AdBanner = ({ position = 'center', style = {} }) => {
    // Conditional check for localhost
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

    useEffect(() => {
        // Only trigger AdSense on non-localhost environments
        if (!isLocalhost) {
            try {
                // Initialize AdSense
                // Check if adsbygoogle is loaded and has not been pushed to recently to avoid "adsbygoogle.push() error: No slot size for availableWidth=0"
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (error) {
                
            }
        }
    }, [isLocalhost]);

    const getPositionStyles = () => {
        const baseStyles = {
            textAlign: 'center',
            minHeight: '100px', // Prevent Layout Shift (CLS)
            padding: '10px'
        };

        switch (position) {
            case 'fixed-bottom':
                return {
                    ...baseStyles,
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 9999,
                    backgroundColor: '#fff',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    margin: 0
                };
            case 'fixed-top':
                return {
                    ...baseStyles,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 9999,
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    margin: 0
                };
            case 'left':
                return {
                    ...baseStyles,
                    float: 'left',
                    marginRight: '15px',
                    marginBottom: '10px',
                    display: 'inline-block',
                    width: 'auto'
                };
            case 'right':
                return {
                    ...baseStyles,
                    float: 'right',
                    marginLeft: '15px',
                    marginBottom: '10px',
                    display: 'inline-block',
                    width: 'auto'
                };
            default: // center, top, bottom (static)
                return {
                    ...baseStyles,
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '10px 0',
                    width: '100%'
                };
        }
    };

    const appliedStyle = { ...getPositionStyles(), ...style };

    // UX Polish: Placeholder for localhost
    if (isLocalhost) {
        return (
            <div style={{
                ...appliedStyle,
                backgroundColor: '#f0f0f0',
                border: '1px dashed #ccc',
                color: '#555',
                fontWeight: 'bold',
                alignItems: 'center', // correct alignment for flex container in default case
                justifyContent: 'center' // ensure text is centered
            }}>
                AdSense Placeholder ({position})
            </div>
        );
    }

    return (
        <div style={appliedStyle}>
            {/* EMt7any_Top_Banner */}
            <ins className="adsbygoogle"
                style={{ display: 'block', textAlign: 'center', width: '100%' }}
                data-ad-client="ca-pub-8885753639266752"
                data-ad-slot="2335010838"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
        </div>
    );
};

export default AdBanner;
